import { render, staticRenderFns } from "./WorkingBLMain.vue?vue&type=template&id=1ed6120e"
import script from "./WorkingBLMain.vue?vue&type=script&lang=js"
export * from "./WorkingBLMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed6120e')) {
      api.createRecord('1ed6120e', component.options)
    } else {
      api.reload('1ed6120e', component.options)
    }
    module.hot.accept("./WorkingBLMain.vue?vue&type=template&id=1ed6120e", function () {
      api.rerender('1ed6120e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingBLMain.vue"
export default component.exports